// extracted by mini-css-extract-plugin
export var collapsedSummary = "_ql-0";